import { gql } from '@apollo/client';

export interface MembershipInputV3 {
  organisation: string;
  roles: string[];
}

export interface CreateUserInputV3 {
  email: string;
  name: string;
  firstName?: string;
  lastName?: string;
  password: string;
  memberships: MembershipInputV3[];
}

export interface CreateUserInputResponseV3 {
  createUserV3: {
    message: string;
  };
}

export const CREATE_USER_V3 = gql`
  mutation createUserV3($input: CreateUserInputV3!) {
    createUserV3(input: $input) {
      message
    }
  }
`;
